var alignmentStyle = {"alignLeft":"pCGJ-","textWrapNowrap":"_9VOmk","alignRight":"_4rkQ5","alignCenter":"jFuOk","sizeFullWidth":"TjDVE","renderedInTable":"j6rfW","sizeOriginal":"Iq2k5","sizeContent":"ymF7P","sizeSmall":"O6UAl","sizeSmallCenter":"sizOT","flex":"_1k4-7","LEFT":"_20DYo","CENTER":"ARoWQ","RIGHT":"_8YKlg","AUTO":"IJ3hO","JUSTIFY":"fVAGg"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-4bcf2c40.js.map
